// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"81787880","455":"98add911"}[chunkId] + ".chunk.js";
};